import styled from 'styled-components';
import './header.less';
import { Row, Col, Avatar, Image, Grid } from 'antd';
const { useBreakpoint } = Grid;
import { useTranslation } from 'react-i18next';
import { useLifeUserProfile, useLifeProfileImage } from 'all-in-one-shared-api';
import { useKeycloakReady } from 'hooks/useKeycloakReady';
import { Root } from 'all-in-one-shared-api/dist/apis/profile/useLifeUserProfile';
import { useEffect, useState } from 'react';
const InboxHeaderContainer = styled.div`
  width: 672px;
  height: 152px;
  margin: -36px auto 16px;
  position: relative;
  z-index: 12;
  background-color: #fff;
  border-radius: 6px;
`;
export const InboxHeader = (props: {
  avatarStatus: boolean;
  sendStatus: () => void;
  sendProfileInfo: (data: Root) => void;
}) =>
  // props: { sendMessage: (message: string) => void }
  {
    const { t } = useTranslation();
    const { token } = useKeycloakReady();
    const { xl, xs } = useBreakpoint();
    const [avatar, setAvatar] = useState('https://pic.rmb.bdstatic.com/bjh/29ec24703f441d078b913970fb206a0e.jpeg');
    const { shouldFetch: lifeProfile, data: useLifeUserProfileData } = useLifeUserProfile(
      'useLifeUserProfile',
      token ?? '',
    );
    const { shouldFetch: LifeProfileImageShouldFetch, data: LifeProfileImageData } = useLifeProfileImage(
      'useLifeProfileImage',
      token ?? '',
    );
    useEffect(() => {
      lifeProfile(true);
    }, [lifeProfile]);
    useEffect(() => {
      if (useLifeUserProfileData) {
        setAvatar(
          useLifeUserProfileData?.pictureUrl ||
            'https://pic.rmb.bdstatic.com/bjh/29ec24703f441d078b913970fb206a0e.jpeg',
        );
        props.sendProfileInfo(useLifeUserProfileData);
      }
    }, [useLifeUserProfileData, props]);
    useEffect(() => {
      if (props.avatarStatus) {
        LifeProfileImageShouldFetch(true);
        setTimeout(() => {
          props.sendStatus();
        }, 1000);
      }
    }, [props, LifeProfileImageShouldFetch]);
    useEffect(() => {
      if (LifeProfileImageData) {
        setAvatar(
          LifeProfileImageData?.pictureUrl || 'https://pic.rmb.bdstatic.com/bjh/29ec24703f441d078b913970fb206a0e.jpeg',
        );
      }
    }, [props, LifeProfileImageData]);
    // useEffect(() => {
    //   if (useLifeUserProfileData) {
    //     props.sendMessage(useLifeUserProfileData?.firstName);
    //   }
    // }, [useLifeUserProfileData]);
    return (
      <InboxHeaderContainer className="account_header">
        <div className="avatar-wrapper">
          <Row className="avatar-content" justify="center" align="middle" style={{ width: '100%', height: '100%' }}>
            <Col span={xl ? 6 : 4}>
              <Avatar
                size={xl ? 104 : xs ? 54 : 72}
                src={<Image src={avatar} style={{ width: '100%', height: '100%' }} />}
              />
            </Col>
            <Col
              span={16}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                justifyContent: 'space-around',
                marginLeft: xl ? '24px' : '20px',
                overflow: 'hidden',
              }}
            >
              <p className="font-size33 red-font profile-name">
                {useLifeUserProfileData?.firstName + ' ' + useLifeUserProfileData?.lastName}
              </p>
              <p className="font-size17 grey-font font-setting500">
                {t('life.lifeProfile.loginId') + ' ' + useLifeUserProfileData?.loginId}
              </p>
            </Col>
          </Row>
        </div>
      </InboxHeaderContainer>
    );
  };
